let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4KiYL")).then(() => parcelRequire('9Wb1k'));